module.exports = __webpack_public_path__ + "static/media/website-07.bfd1f98f.png";